// extracted by mini-css-extract-plugin
export default {"title":"vFk0tz","subtitle":"wJXcgX","card":"yCoEEB","cardTitle":"z_yD6q","titleAndSubtitle":"Cv1cBi"};